<template>
        <div class="card shadow-sm card-hover" :class="{ 'border-light' : !(cardActive || false), 'border-enabled' : (cardActive || false) }">
            <div class="card-body">
                <b-overlay :show="!(cardActive || false)" :opacity="0.4" spinner-type="null">
                <div class="text-center pd-2 pr-2" style="cursor: pointer;" :onclick="'window.open(\'' + link + '\', \'_self\');'">
                        <i class="fad fa-3x fa-icon-highlight-light" :class="iconClass"></i>
                        <h5>{{title}}</h5>
                        <hr class="highlight" />
                    </div>
                <div class="d-flex justify-content-between" style="min-height: 64px;">
                    <p class="card-text" v-html="description"></p>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-2">
                    <a class="btn btn-outline-dark btn-block" :href="link" ><i class="far" :class="iconClass"></i> {{buttonText}}</a>
                </div>
                </b-overlay>
            </div>
            <div class="card-footer">
                <small class="text-muted" v-html="footer"></small>
            </div>
        </div>
</template>

<script>
    
    export default {
        name: "PortalModuleExternalCard",
        props :['iconClass','title','description','buttonText', 'footer', 'link', 'cardActive'],
        data(){
          return {
          }  
        },
        computed:{
        },
        created() {
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>